module.exports = __webpack_public_path__ + "img/05-3黄金24小时.11fea221.png";